/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================= Breeze ======================= */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = 'slim';
var klevu_productsToShowInSlimLayout = 6;

klevu.extend(true, klevu.search.modules, {
  productImageReverse: {
    base: {
      reverse: function(data, scope){
        try {
          var products = klevu.getObjectPath(data.template, "query.productList.result", false);
          if (products) {
            klevu.each(products, function(indx, product) {
              var klevu_productImage = product.image;
              var klevu_productHover = product.imageHover;
          
              console.log(product,'products')
          
              product.image = klevu_productHover;
              product.imageHover = klevu_productImage;
                
            });
          }    
        } catch (e) {}
      }
    }
  }
});

klevu.beforeActivation("quick", function(data, scope){
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickProductBlockTitleHeaderCustom, 'klevuQuickProductBlockTitleHeader', true);
        box.getScope().template.setTemplate(klevuQuickProductBlockCustom, 'klevuQuickProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
        box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, 'klevuQuickTrendingProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickRecentViewedProductBlockCustom, 'klevuQuickRecentViewedProductBlock', true);
        box.getScope().template.setTemplate(klevuSearchPersonalizationsCustom, 'klevuSearchPersonalizations', true);
    });
});

klevu.modifyResponse('quick', klevu.search.modules.productImageReverse.base.reverse);

klevu.afterTemplateRender('quick', function (data, scope) {
    function setKlevuQuickPopupTopPositionVariable() {
        klevu.each(klevu.dom.find('.kuQuickSearchAutoCompleteLayout .klevuWrap'), function (key, currentElement) {
            const topPosition = currentElement.getBoundingClientRect().top;
            document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
        });
    }
    setKlevuQuickPopupTopPositionVariable();
    window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);

});
/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickProductBlockTitleHeaderCustom = `
<div class="klevuSuggestionHeading">
    <span class="klevuHeadingText"><%=helper.translate("Products")%></span>
    </div>
    <div class="klevuProductsViewAll">
    <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
    <a class="link" href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>" target="_parent"><%=helper.translate("View All")%></a>
</div>`;

var klevuQuickProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
            </div>
        </div>
        <div class="klevuProductItemBottom">
            <div class="klevuQuickProductDescBlock">
                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResultsClass %>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                            <% if(quickFacetedLayoutMessage != "") { %>
                                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                            <% } %>                    
                        <% } else { %>
                            <% if(data.query.productList) { %>
                                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                                <%= helper.render('klevuQuickProducts',scope) %>
                                <%= helper.render('klevuQuickOtherContent',scope) %>
                            <% } else { %>              
                                <div class="kuSearchPersonalizationsContainer">
                                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                                </div>
                            <% } %>  
                        <% } %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    </div>
                </section>
            </header>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
        </div>
    </div>
</div>`;

var klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') {
    updatedProductName = updatedProductName.replace(dataLocal.brand, '');
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
    </div>
</div>
<div class="klevuProductItemBottom">
    <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
        <div class="klevu-brand"><%= dataLocal.brand %></div>
    <% } %>
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>`;

var klevuQuickRecentViewedProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuTrackRecentView kuQSMenuItemTarget">
    <div class="klevuProductItemTop">
        <div class="klevuQuickImgWrap">
            <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
            <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
        </div>
    </div>
    <div class="klevuProductItemBottom">
        <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
            <div class="klevu-brand"><%= dataLocal.brand %></div>
        <% } %>
        <div class="klevuQuickProductDescBlock">
            <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
            <div class="klevuQuickProductDesc">
                <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div> <div class="klevuQuickProductPrice">
                <%
                    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                %>
                <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                    <div class="klevuQuickSalePrice kuStartPrice">
                        <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                        <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                    </div>
                <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                    <span class="klevuQuickOrigPrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                    <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                        <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                    </span>
                <% } else if(!Number.isNaN(kuSalePrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                    </span>
                <% } else if(!Number.isNaN(kuPrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                <% } %>
            </div>
            </div>                
        </div>
    </div>        
</a>`;

var klevuSearchPersonalizationsCustom = `
<div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
<section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
    <div ku-block data-block-id="ku_quick_left_facets"></div>
    <div ku-block data-block-id="ku_quick_left_call_outs">
        <%=helper.render('kuTemplatePopularSearches',scope) %>
        <%=helper.render('kuTemplateRecentSearches',scope) %>
    </div>
    <% if (window.innerWidth >= 768) { %>
        <div ku-block data-block-id="ku_quick_left_banner"></div>
    <% } %>
</section>
<section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
    <header ku-block data-block-id="ku_quick_result_header"></header>
    <div ku-block data-block-id="ku_quick_result_items"></div>
                
    <div ku-block data-block-id="ku_quick_other_items">
        <%=helper.render('klevuTrendingProducts',scope) %>
        <% if (window.innerWidth < 768) { %>
            <div ku-block data-block-id="ku_quick_left_banner"></div>
        <% } %>
        <%=helper.render('klevuRecentViewedProducts',scope) %>
    </div>

    <footer ku-block data-block-id="ku_quick_result_footer"></footer>
</section>
<section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
    <div ku-block data-block-id="ku_quick_right_facets"></div>
    <div ku-block data-block-id="ku_quick_right_call_outs"></div>
    <div ku-block data-block-id="ku_quick_right_banner"></div>
</section>
</div>`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ====================== Blossom ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu.beforeActivation("catnav,landing", function (data, scope) {

    scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);
    scope.kScope.template.setTemplate(landingPageProductColorSwatchesCustom, 'landingProductSwatch', true);
    scope.kScope.template.setTemplate(klevuLandingProductRatingCustom, 'klevuLandingProductRating', true);
    scope.kScope.template.setTemplate(kuFilterTagsTemplateCustom, 'kuFilterTagsTemplate', true);

    scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });

    (function (klevu) {
        klevu.extend(true, klevu.search.modules, {
            addParamsToURL: {
                base: {
                    addURLtoHistory: function (data, scope, queryId) {
                        // Global stuff
                        if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                            console.error("This browser does not have the support of window.history or window.history.pushState");
                            return;
                        }

                        var searchPath = new URLSearchParams(window.location.search);
                        var currentSearchPath;
                        var previousSearchPath = searchPath.toString();

                        // this is in case we're running our code where we dont have context.activeQueryId
                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                        if (queryId && queryId.length) {
                            activeQueryId = queryId;
                        }

                        // Check if there any filter selected
                        let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                        let isThereFiltersSelected = false;
                        // Check if applyFilters is an object (but not an array), and not empty
                        if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                            isThereFiltersSelected = true;
                        }

                        // PAGINATION TO URL
                        var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                        var paginationQueryParam = "Page";
                        var currentPage = 0;

                        if (hasPaginationEnabled) {
                            var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                            if (activeQueryMeta) {
                                var productListLimit = activeQueryMeta.noOfResults;
                                currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                            }

                            if (currentPage === 0 || currentPage === 1) {
                                searchPath.delete(paginationQueryParam);
                            } else {
                                searchPath.set(paginationQueryParam, currentPage);
                            }

                            currentSearchPath = searchPath.toString();
                        };

                        // FILTERS TO URL
                        var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                        var filterValuesQueryParam = "";

                        if (activeQueryFilters) {
                            klevu.each(activeQueryFilters, function (key, filter) {
                                var selectedFilterKeyString = "";
                                var filterOptions = filter.options;
                                var selectedValues = "";

                                if (filterOptions && filterOptions.length) {
                                    klevu.each(filterOptions, function (key, option) {
                                        if (option.selected === true) {
                                            if (selectedValues.length) {
                                                selectedValues += ",";
                                            }
                                            selectedValues += option.value;
                                        }
                                    });
                                } else if (filter.type === "SLIDER") {
                                    var startValue = filter.start;
                                    var endValue = filter.end;
                                    var minValue = filter.min;
                                    var maxValue = filter.max;
                                    if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                        if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                            // just skipping
                                        } else {
                                            selectedValues = startValue + "-" + endValue;
                                        }
                                    }
                                }

                                if (selectedValues.length) {
                                    // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                    selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                }

                                if (selectedFilterKeyString.length) {
                                    if (filterValuesQueryParam.length) {
                                        filterValuesQueryParam += ";";
                                    }
                                    filterValuesQueryParam += selectedFilterKeyString;
                                }
                            });
                        }

                        if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                            searchPath.set("Filters", filterValuesQueryParam);
                        } else {
                            searchPath.delete("Filters");
                        }

                        currentSearchPath = searchPath.toString();

                        // ==============================
                        // Final URL change
                        if (previousSearchPath !== currentSearchPath) {
                            var historyState = { page: currentPage, filters: currentSearchPath };
                            window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                        }
                    },

                    restoreSearchParamsOnPageLoad: function (data, scope) {
                        var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                        if (hasAlreadyTriggered) return;

                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

                        var matchedQueryParamId = "";
                        var matchedQueryParamValue = "";
                        var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id) {
                                    if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                        matchedQueryParamId = recordQuery.id;
                                        matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                    }
                                }
                            });
                        }

                        klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

                        matchedQueryParamId = activeQueryId || "productList";

                        if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                            activeQueryId = matchedQueryParamId;
                            var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                            if (storage.tabs) {
                                storage.tabs.setStorage("local");
                                storage.tabs.mergeFromGlobal();
                                storage.tabs.addElement("active", activeQueryId);
                                storage.tabs.mergeToGlobal();
                            }
                        }

                        if (paginationFromURL && paginationFromURL > 1) {
                            if (recordQueries && recordQueries.length) {
                                klevu.each(recordQueries, function (key, recordQuery) {
                                    if (recordQuery.id === activeQueryId) {
                                        var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                        limit = Number(limit);
                                        if (limit > 0) {
                                            var expectedOffset = (paginationFromURL - 1) * limit;
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                        }
                                    }
                                });
                            }
                        }

                        // FILTERS
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            if (facets) {
                                klevu.each(facets, function (key, facet) {
                                    var splitFacet = facet.split(":");
                                    if (splitFacet.length) {
                                        var facetKey = decodeURIComponent(splitFacet[0]);
                                        var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                        var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                                        if (applyFilters && applyFilters.length) { // if there're some filters
                                            var isExistingKey = false;
                                            klevu.each(applyFilters, function (key, applyFilter) {
                                                if (applyFilter.key === facetKey) {
                                                    isExistingKey = true;
                                                    klevu.each(facetValues, function (key, facetValue) {
                                                        var isFilterOptionMatched = false;
                                                        klevu.each(applyFilter.values, function (key, value) {
                                                            if (facetValue === value) {
                                                                isFilterOptionMatched = true;
                                                            }
                                                        });
                                                        if (!isFilterOptionMatched) {
                                                            applyFilter.values.push(facetValue);
                                                        }
                                                    });
                                                }
                                            });
                                            if (!isExistingKey) {
                                                applyFilters.push({ key: facetKey, values: facetValues });
                                            }
                                        } else {
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                        }

                                    }
                                });
                            }
                        }
                    },

                    updatePayloadOnPopState: function (data, scope, activeQueryId) {
                        // SET PAGINATION PAYLOAD
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                        paginationFromURL = Number(paginationFromURL);
                        var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
                        limit = Number(limit);
                        if (limit > 0) {
                            var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                            // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                        }

                        // SET FILTER PAYLOAD
                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            // loop through all facets to get its values
                            let facetKey = '';
                            let facetValues = [];
                            let facetsArray = [];

                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    facetKey = decodeURIComponent(splitFacet[0]);
                                    facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                    facetsArray.push({ key: facetKey, values: facetValues });
                                }
                            });
                            // set the payload with correct filters:
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                        } else { // reset filters if Back button pressed, and there's no filters
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                        }
                    }
                },
                build: true
            },
            filterOpener: function (data, scope) {
                var filterOpener = document.querySelector('.ku-facet-opener');
                var filterClose = document.querySelector('.ku-facet-close');
                var filterApply = document.querySelector('.kuFiltersMobButton_apply');
                var landingElement = document.querySelector('.klevuLanding');
                if (filterOpener && landingElement) {
                    klevu.event.attach(filterOpener, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
                if (filterClose && landingElement) {
                    klevu.event.attach(filterClose, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
                if (filterApply && landingElement) {
                    klevu.event.attach(filterApply, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
            },
            insertToTopButton: function (data, scope) {
                let topButton = document.getElementById('ku-back-to-top');
                if (!topButton) {
                    topButton = document.createElement('button');
                    topButton.id = 'ku-back-to-top';
                    topButton.title = 'Back to top';
                    topButton.className = 'ku-hide';
                    topButton.textContent = '↑';
                    document.body.appendChild(topButton);
                }

            },
            addBodyClassOnScroll: function () {
                // Helper function to get the top position of an element
                function getElementYPosition () {
                    var element = document.querySelector('.kuResultsListing');
                    if (element) {
                        var boundingClientRect = element.getBoundingClientRect();
                        var absoluteElementTop = boundingClientRect.top + window.pageYOffset;
                        return absoluteElementTop;
                    }
                    return null; // Return null if the element doesn't exist
                };
                window.addEventListener('scroll', function (e) {
                    const positionY = window.scrollY;
                    const productListPositionY = getElementYPosition();
                    const triggerPositionY = productListPositionY !== null ? productListPositionY : 100;
                    const body = document.body;
                    const shouldAddClass = positionY >= triggerPositionY;
                    body.classList.toggle('klevu-sticky', shouldAddClass);
                });
            },
            smoothScrollToProductListingTop: function () {
                let customOffset = 60;
                const selectorsToTriggerScrollToTop = {
                    pagination: '.kuPagination a',
                    scrollToTopButton: '#ku-back-to-top'
                  // filterOptions: '.klevuFilterOption',
                  // Add more selectors here as needed
                }
                function _smoothScrollToKlevuTop() {
                  setTimeout(function () {
                      var target = document.getElementsByClassName('klevuMeta')[0];
          
                      if (target) {
                          var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
          
                          window.scrollTo({
                              top: topPosition - customOffset,
                              behavior: 'smooth'
                          });
                      }
                  }, 100);
                }
                Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                  document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
                });
            },      
            keepFacetsWithSelectedOptionsOpened: function (data, scope) {
                const selectors = {
                    kuFilterBox: '.kuFilterBox',
                    kuSelected: '.kuSelected',
                    kuFilterNames: '.kuFilterNames',
                    kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
                    kuFilterHead: '.kuFilterHead',
                    kuFilterHeadExpand: '.kuFilterHead.kuExpand',
                    kuExpand: '.kuExpand',
                    kuCollapse: '.kuCollapse',
                    nouiElement: '.noUi-origin',
                    priceFacetBlock: '[data-filter="klevu_price"]',
                    kuFilterShowAll: '.kuFilterShowAll',
                    kuFilterCollapse: '.kuFilterCollapse',
                };
        
                /** Collapse Filters by default */
                (function collapseAllFilters() {
                    // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
                    const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
                    kuFilterHeadElements.forEach(element => {
                        element.classList.add(selectors.kuExpand.substring(1));
                        element.classList.remove(selectors.kuCollapse.substring(1));
                    });
        
                    // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
                    const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);
                    kuFilterNamesElements.forEach(element => {
                        element.classList.add(selectors.kuFilterCollapse.substring(1));
                        element.classList.remove(selectors.kuFilterShowAll.substring(1));
                    });
                }());
        
        
                // Regular checkbox-facets
                // Check if the required elements exist
                const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
                if (kuSelectedElements.length > 0) {
                    kuSelectedElements.forEach(selectedElement => {
                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);
        
                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
        
                        // Rotate icon in the title 
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }
        
                        // Find the parent element with the class kuFilterNames.kuFilterCollapse
                        const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);
        
                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }
                    });
                }
        
                    // Price slider facet
                    var isThereAnyAppliedFacets = klevu.getObjectPath(
                        scope.kScope.data,
                        "localOverrides.query." +
                        scope.kScope.data.context.activeQueryId +
                        ".filters.applyFilters.filters"
                    );
                    const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
                    if (isPriceFacetApplied) {
                    // Find the parent element with the class kuFilterNames.kuFilterCollapse
                    const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);
        
                    if (nouiElement) {
                        const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);
        
                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }
        
                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);
        
                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
        
                        // Rotate icon in the title
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }
                    }
                }
        
                // Function-helper to find the parent element with a specified class
                function findParentWithClass(element, className) {
                    let parent = element.parentElement;
                    while (parent) {
                        if (parent.matches(className)) {
                            return parent;
                        }
                        parent = parent.parentElement;
                    }
                    return null; // No matching parent found
                }
            }
        });
    })(klevu);

})

// Apply the facets supplied in the current URL string
klevu.modifyRequest("catnav,landing", function (data, scope) {

    if (localStorage.getItem('klv_sort_productList') !== null) {
        localStorage.removeItem('klv_sort_productList');
    }

    klevu.each(data.request.current.recordQueries, function (key, query) { 
      query.filters.filtersToReturn.options.limit = 21; 
      
      var landingStorage = klevu.getSetting(
              scope.kScope.settings,
              "settings.storage"
            );
      
          var sort = landingStorage.sort.getElement(query.id) == query.id
                  ? false
                  : landingStorage.sort.getElement(query.id);
              if (
                sort &&
                (sort === "RATING_ASC" || sort === "RATING_DESC")
              ) {
                var sortDirection = sort.split("_")[1];
                query.settings.sort = "ADVANCED_SORT";
                query.settings.advancedSorting = [
                  {
                    type: "FIELD",
                    key: "custom_rating_count",
                    order: sortDirection
                  }
                ];
          }
    });

    // Restore Search Params On Page Load
    klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

    // set the global scope
    window.klevuCurrentScope = scope.kScope;
});

klevu.modifyResponse('landing', klevu.search.modules.productImageReverse.base.reverse);

klevu.modifyResponse("landing,catnav", function(data, scope){
  klevu.each(data.template.query.productList.filters, function(indx, filter)
  {
      if (filter.key === "size") {
        const optionOrder = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "S / M", "M / L", "L / XL", "ONE SIZE"];
		optionOrder.reverse().forEach(function(elm) {
			filter.options.sort(function (a, b) {
				if (a.name === elm)  return -1;
				if (a.name !== elm && b.name !== elm)  return 0;
				return 1;
			});
		});
      }
  });
});

window.klevu_color_swatches_data = {};
klevu.afterTemplateRender("catnav,landing", function (data, scope) {
    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    klevu.search.modules.insertToTopButton(data, scope);
    klevu.search.modules.filterOpener(data, scope);
    klevu.search.modules.addBodyClassOnScroll();    
    klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);
    klevu.search.modules.smoothScrollToProductListingTop(data, scope);

    try {

        if(document.querySelectorAll('[data-filter="colorfilter"]').length) {
            const el = document.querySelector('[data-filter="colorfilter"] .kuFilterNames');

             if (el) {
                const height = el.offsetHeight;
                
                if (height <= 180) {
                    el.classList.add('small-height');
                }
            }
        }

      /* GET all the product IDs in the response */
      var productIds = data.template.query.productList.result;

      /* LOOP through the IDs */
      klevu.each(productIds, async function (pkey, prod) {

        /* FETCH the product template from Shopify API */
        var res = await fetch(prod.url + '?view=klevu-color-swatches');
        var colorSwatches = await res.json();
        
        /* INSERT the template markup into the placeholder */
        var productSwatches = document.querySelectorAll('[data-id="' + prod.id + '"] .klevuLandingSwatchColorGrid');

        var productVariantCount = document.querySelector('[data-id="' + prod.id + '"] .kuSwatchMoreText');
        if(Object.keys(colorSwatches).length > 5) {
          if(productVariantCount){
            document.querySelector('[data-id="' + prod.id + '"] .kuSwatchMore .kuSwatchMoreText').innerText = `+${Object.keys(colorSwatches).length - prod.swatchesInfo.length} More`;
          }else {
            const kuSwatchesElement = document.querySelector('[data-id="' + prod.id + '"] .kuSwatches');

             if(kuSwatchesElement){
                kuSwatchesElement.insertAdjacentHTML(
                    'beforeend',
                    `
                    <div class="kuSwatchMore">
                        <a target="_self" href="${prod.url}" class="kuSwatchLink">
                            <span class="kuSwatchMoreText">+${Object.keys(colorSwatches).length - prod.swatchesInfo.length} More</span>
                        </a>
                    </div>
                    `
                );
             }
          }
        }
        
        klevu.each(productSwatches, function (skey, swatchEl) {
          
          if (swatchEl.dataset.variantColorName && colorSwatches[swatchEl.dataset.variantColorName]) {
            if (typeof klevu_color_swatches_data[swatchEl.dataset.variantColorName] === 'undefined') {
              klevu_color_swatches_data[swatchEl.dataset.variantColorName] = colorSwatches[swatchEl.dataset.variantColorName];
            }
            swatchEl.style = colorSwatches[swatchEl.dataset.variantColorName];
          }
        });
      
      });
            
     } catch (err) {
       /* If we have any issues processing the above code let's log the error */
       console.log('Not able to process this product because:' + err, prod);
     }

});

window.onpopstate = function (event) {
    try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
        // code to get ready to reset all the data
        var data = window.klevuCurrentScope.element.kObject.getScope().data;
        var scope = window.klevuCurrentScope.element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;

        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

        // Fire request, re-render results
        klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
    } catch (error) {
        console.log(error)
    }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingProductRatingCustom = `
  <% if(dataLocal.ratingCount && dataLocal.rating) { %>  
    <div class="productRating-klevu">
      <div class="custom-stars" data-rating="<%= dataLocal.rating %>">
        <% 
          const fullStars = Math.floor(dataLocal.rating);
          const halfStar = (dataLocal.rating % 1 >= 0.5);
          const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);
        %>
  
        <% for (let i = 0; i < fullStars; i++) { %>
          <span class="star full">&#9733;</span>
        <% } %>
  
        <% if (halfStar) { %>
          <span class="star half">&#9733;</span>
        <% } %>
  
        <% for (let i = 0; i < emptyStars; i++) { %>
          <span class="star empty">&#9733;</span>
        <% } %>
      </div>
      <div class="review-count">
        (<%= dataLocal.ratingCount %>)
      </div>
    </div>
  <% } %>`;

var landingPageProductColorSwatchesCustom = `
    <%  
        var hasAnyVariantImageAdded = false;
        if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length) {
            helper.each(dataLocal.swatchesInfo,function(key,item) {
                if(item.variantImage && item.variantImage.length) {
                    hasAnyVariantImageAdded = true;
                }
            });
        }
    %>

    <% if(((!dataLocal.swatchesInfo || !dataLocal.swatchesInfo.length) || !hasAnyVariantImageAdded) && dataLocal.totalVariants) { %>
        <div class="kuSwatches">
            <span class="kuSwatchesVariantCountText">+<%= dataLocal.totalVariants %> <%= helper.translate("variant(s)") %></span>
        </div>
    <% } %>

    <% if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length && hasAnyVariantImageAdded) { %>
        <div class="kuSwatches">
            <% 
                var totalVariantIndex = Number(dataLocal.totalVariants);
                var swatchIndex = 0;
                helper.each(dataLocal.swatchesInfo,function(key,item) {
                    var isSwatchInfoAdded = false;
                    if(swatchIndex > 4){ return true; }
                    if(item.variantImage && item.variantImage.length) {
            %>

                            <div class="kuSwatchItem">
                                <a 
                                    target="_self" 
                                    href="javascript:void(0)" 
                                    data-variant="<%= item.variantId %>" 
                                    class="kuSwatchLink klevuLandingSwatchColorGrid"
                                    data-variant-color-name="<%= item.variantColor %>"
                                    <% if(item.variantColor && item.variantColor.length) { %>
                                        title="<%= item.variantColor %>"
                                    <% } %>
                                    style="<% if(item.variantColor && item.variantColor.length) { isSwatchInfoAdded = true; %>
                                            background-color:<%= item.variantColor %>;
                                        <% } %>
                                        <% if(item.variantSwatchImage && item.variantSwatchImage.length) { isSwatchInfoAdded = true; %>
                                            background-image: url('<%= item.variantSwatchImage %>');
                                        <% } %>
                                        <% if(!isSwatchInfoAdded) {  %>
                                            background-image: url('https://js.klevu.com/klevu-js-v1/img-1-1/default-swatch.jpg');
                                        <% } %>"
                                >
                                </a>
                            </div>

            <%          
                        swatchIndex++;
                    }                    
                });
            %>

       </div>	
   <% } %>`;

var klevuLandingTemplateFiltersCustom = `
    <% if(data.query[dataLocal].filters.length > 0 ) { %>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
        <div class="kuFiltersMobButtons">
            <button class="kuFiltersMobButton kuFiltersMobButton_apply" tabindex="0"><%= helper.translate("Apply")%></button>
            <button class="kuFiltersMobButton kuFiltersMobButton_reset kuFilterTagClearAll" tabindex="0">Reset</button>
        </div>

        <h3 class="kuFiltersTitleHeading"><%=helper.translate("Filter by")%></h3>

            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <% if(filter.key == "colorfilter"){ %>
                                        <a
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive klevu-color-swatch-selected <% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                            style="background-color: <%=helper.escapeHTML(filterOption.name)%>; display: inline-block; width: 30px; height: 30px; border-radius: 50%; border: 1px solid #ccc;"

                                        >
                                            
                                        </a>
                                        
                                        <% } else { %>
                                          <a
                                              target="_self" 
                                              href="#" 
                                              title="<%=helper.escapeHTML(filterOption.name)%>" 
                                              class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                              data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                              data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                          >
                                              <span class="kuFilterIcon"></span>
                                              <span class="kufacet-text"><%=filterOption.name%></span>
                                              <% if(filterOption.selected ==true) { %>
                                                  <span class="kuFilterCancel">X</span>
                                              <% } else { %>
                                                  <span class="kuFilterTotal"><%=filterOption.count%></span>
                                              <% } %>
                                          </a>
                                        <% } %>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                            <% if(filter.options.length >= 7 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                	<div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        	<% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
  							<div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
  								<div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
  							</div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>
            
            <!-- <div class="kuFiltersFooter">
            	<a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  			</div> -->
            
            
        </div>
        <button class="ku-facet-close"><span class="mobile-filter__close"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" class="icon icon__close uc__hideFacets" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg></span><%= helper.translate("Close")%></button>
    <% } %>
`;

var klevuLandingTemplateResultsCustom = `
    <div class="kuResultsListing">
        <div class="productList klevuMeta" data-section="productList">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div class="ku-text-found">
                        <% if (data?.settings?.categoryPath === undefined) { %>
                                <h2><%=data.query.productList.meta.totalResultsFound %> <%= helper.translate("PRODUCTS FOUND FOR") %> "<%=data.query.productList.meta.searchedTerm %>"</h2>
                        <% } else { %>
                                <h2><%= data.settings.categoryPath %> </h2>
                        <% } %>
                    </div>

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">                                
                                <%=helper.render('filters',scope,data,"productList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <% 
                                    var lastPageResults = (Number(data.query.productList.meta.noOfResults) + Number(data.query.productList.meta.offset)) > data.query.productList.meta.totalResultsFound ? data.query.productList.meta.totalResultsFound : (Number(data.query.productList.meta.noOfResults) + Number(data.query.productList.meta.offset));
                                    var results = ((Number(data.query.productList.meta.offset) !== 0) ? Number(data.query.productList.meta.offset) : '') + ' - ' + lastPageResults;
                                    if(results > data.query.productList.meta.totalResultsFound){
                                        results = data.query.productList.meta.totalResultsFound;
                                    }
                                %>
                                <div class="ku-numberOfResults">showing <%= results %> of <%=data.query.productList.meta.totalResultsFound %></div>
                                <button class="ku-facet-opener"><span>Filter Selection</span></button>
                                <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%=helper.render('filtersTop',scope,data,"productList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <%=helper.render('sortBy',scope,data,"productList") %>
                                    <%=helper.render('limit',scope,data,"productList") %>
                                    <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                                    <%=helper.render('pagination',scope,data,"productList") %>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"productList")) { %>
                                        <ul>
                                            <% helper.each(data.query.productList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                    <%=helper.render('productBlock',scope,data,item) %>
                                                <% } %>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('pagination',scope,data,"productList") %>
                            <% } %>
                            
                            
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>

        <% if(data.query.contentList) { %>
            <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
                <div class="kuResultContent">
                    <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">
                        
                        <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                            <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                                <div ku-block data-block-id="ku_landing_left_facets">
                                    
                                    <%=helper.render('filters',scope,data,"contentList") %>

                                </div>
                                <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_left_banner"></div>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                                
                                <header ku-block data-block-id="ku_landing_result_header">
                                    <%=helper.render('filtersTop',scope,data,"contentList") %>
                                    <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <%=helper.render('limit',scope,data,"contentList") %>
                                        <%=helper.render('pagination',scope,data,"contentList") %>
                                    <% } %>
                                    <div class="kuClearBoth"></div> 
                                </header>

                                <div ku-block data-block-id="ku_landing_result_items">
                                    <div class="kuClearBoth"></div>
                                    <div class="kuResults">
                                        <% if(helper.hasResults(data,"contentList")) { %>
                                            <ul>
                                                <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                    <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                        <%=helper.render('contentBlock',scope,data,item) %>
                                                    <% }%>
                                                <% }); %>
                                            </ul>
                                        <% } else { %>
                                            <div class="kuNoRecordsFoundLabelTextContainer">
                                                <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                            </div>
                                        <% } %>
                                        <div class="kuClearBoth"></div>
                                    </div>
                                </div>
                                <div ku-block data-block-id="ku_landing_other_items">
                                    <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                                </div>
                                <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                                <div ku-block data-block-id="ku_landing_right_facets"></div>
                                <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_right_banner"></div>
                            </section>
                        </div>
                        
                    </div>
                </div>
            </div>
        <% } %> 

    </div>
`;

var  kuFilterTagsTemplateCustom = `

    <% 
        var filterTagsModule = data.filterTags;
        var filterTagsData = [];
        if(dataLocal && dataLocal.length){
            filterTagsData = filterTagsModule.query[dataLocal].tags;
        }
    %>
    <% if(filterTagsData.length) { %>
        <div class="kuFilterTagsContainer">        
            <% helper.each(filterTagsData, function(key,item){ 
                var filterTagItemKey = helper.escapeHTML(item.key);
                var filterTagItemLabel = helper.escapeHTML(helper.translate(item.label));
                %>
                <span 
                    class="kuFilterTag" 
                    data-key="<%= filterTagItemKey %>"
                    data-type="<%= helper.escapeHTML(item.type) %>"
                >
                    <span 
                        title="<%= filterTagItemLabel %>" 
                        data-value="<%= filterTagItemLabel %>" 
                        class="kuFilterTagKey"
                    >
                        <%= helper.translate(item.label) %>
                    </span>
                    <% helper.each(item.values, function(key,option){ %>
                        <% if(item.type === "RATING") { %>
                            <span 
                                title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                class="kuFilterTagValue">
                                <div class="klevuFacetStars">
                                    <div class="klevuFacetRating" style="width:<%=(20*Number(option))%>%;"></div>
                                </div>
                                <span>&times;</span>
                            </span>
                        <% } else { %>
                            <% if (filterTagItemKey === "colorfilter") { %>
                                <span 
                                    title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                    data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                    class="kuFilterTagValue someOtherType swatch"
                                    style="background-color: <%= helper.translate(option) %>">
                                    <!-- Custom content for SOME_OTHER_TYPE -->
                                    
                                    <span>&times;</span>
                                </span>
                            <% } else { %>
                                <span 
                                    title="<%= helper.escapeHTML(helper.translate(option)) %>" 
                                    data-value="<%= helper.escapeHTML(helper.translate(option)) %>"
                                    class="kuFilterTagValue">
                                    <%= helper.translate(option) %>
                                    <span>&times;</span>
                                </span>
                            <% } %>
                        <% } %>
                    <% }); %>
                </span>
            <% }); %>
            <span title="<%= helper.translate("Clear all") %>" class="kuFilterTagClearAll"><%= helper.translate("Clear all") %></span>
        </div>
    <% } %>`;